import CreateWidgetDialog from './CreateWidgetDialog';
export default CreateWidgetDialog; 



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/CreateWidgetDialog/index.js